var _defs, _circle, _g, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereumCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "eth-shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0.25,
    stdDeviation: 0.3,
    floodColor: "#000",
    floodOpacity: 0.4
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ethereum") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#4A63D6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#eth-shadow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "8,2.6 11.7,8.0 8,9.7 4.3,8.0",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8,9.7 11.7,8.0 8,13.4 4.3,8.0",
    fill: "#FFFFFF",
    opacity: 0.8
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumCircle);
export default __webpack_public_path__ + "static/media/ethereum-circle.ff843f04fa4d0c9206381e594ef09521.svg";
export { ForwardRef as ReactComponent };